import React from "react";
import { ItemCard } from "../../SubProductCard";
import { Button } from "@/components/Button";
import { droppsProductToProductCardProduct } from "../../helpers";
import { Box } from "../../BoxSchedule";
export type OrderProcessedPageProps = {
  onExit: () => void;
  box: Box | undefined;
};
const OrderProcessedPage = ({ onExit, box }: OrderProcessedPageProps) => {
  if (!box) return null;
  const { items } = box;
  return (
    <>
      <h3 className="subtitle text-base font-semibold">order processed!</h3>
      <p className="body text-sm">
        Your subscription is now being prepared for shipment. Check your email
        for confirmation or visit the Order History tab for full details.
      </p>
      <div className="space-y-4">
        {items.map((s) => {
          const { product, variant, rechargeItem } = s;
          const productCardProduct = droppsProductToProductCardProduct({
            product,
            variant,
          });
          return (
            <ItemCard
              key={product.id}
              product={productCardProduct}
              price={rechargeItem.price}
              quantity={rechargeItem.quantity}
              shippingInfo={rechargeItem.cadence ?? undefined}
              className="rounded border border-solid border-primary"
              isSubBadge={rechargeItem.status === "ONETIME" ? false : true}
            />
          );
        })}
      </div>
      <Button className="w-full" onClick={onExit}>
        Close
      </Button>
      <Button
        className="w-full"
        variant="outline"
        onClick={() => {
          window.location.href = "/account";
        }}
      >
        {"view order history"}
      </Button>
    </>
  );
};

export { OrderProcessedPage };
